export interface TemplateSearchContentProps {
  containsSearchInDropdown?: boolean;
  onSelectItem?: () => void;
}

export enum SearchPillTypes {
  TEMPLATE = 1,
  MY_DESIGNS = 2,
  AI = 3,
}